export const hasFeatureBeenDiscovered = (
	discoveredFeatures,
	{ pluginKey = '', featureKey = '' } = {},
) =>
	(typeof discoveredFeatures?.some === 'function' ? discoveredFeatures : []).some(
		(discoveredFeature) =>
			discoveredFeature?.pluginKey === pluginKey && discoveredFeature?.featureKey === featureKey,
	);
